import { render, staticRenderFns } from "./PromoItemMenu.vue?vue&type=template&id=64df9be4&scoped=true&lang=pug"
import script from "./PromoItemMenu.vue?vue&type=script&lang=js"
export * from "./PromoItemMenu.vue?vue&type=script&lang=js"
import style0 from "./PromoItemMenu.vue?vue&type=style&index=0&id=64df9be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64df9be4",
  null
  
)

export default component.exports